import { useEffect, useState } from "react";
import { useTranslate } from '../../customHooks';
import { SubscriptionCreate } from './SubscriptionCreate';
import { SubscriptionAccountLinked } from "./SubscriptionAccountLinked";
import CircularLoader from "../../components/CircularLoader/CircularLoader";
import getUrlParameter from "../../utils/GetUrlParameter";
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";
import { SubscriptionLinkAccount } from "./SubscriptionLinkAccount";
import { pendoInitialize } from "../Pendo";
import { SUBSCRIPTION_ACCOUNT_STATUS } from "../../utils/constants";

const SignUpV2 = (props: any) => {
    const [globalLoading, setGlobalLoading] = useState(false);
    const location = useLocation<{ state: any, tokens: any, queryString: any }>();
    const ACCOUNT_STATUS = getUrlParameter("link-state");

    useEffect(() => {
        pendoInitialize({});
    }, []);

    if (globalLoading) {
        return (
            <CircularLoader loading={globalLoading} />
        )
    }

    return (
        <div className={`tw-bg-white tw-rounded-lg tw-h-full`}>
            <div className="tw-py-4 tw-px-5">
                {(!isEmpty(location.state) && !isEmpty((location.state as any)?.tokens)) ?
                    (
                        <SubscriptionLinkAccount state={location.state} />
                    )
                    : (ACCOUNT_STATUS === SUBSCRIPTION_ACCOUNT_STATUS.ASSOCIATE_PENDING || ACCOUNT_STATUS === SUBSCRIPTION_ACCOUNT_STATUS.NULL) ?
                        (
                            <SubscriptionCreate setHasCode={props.setHasCode}/>
                        ) : (
                            <SubscriptionAccountLinked setHasCode={props.setHasCode} />
                )}
            </div>
        </div>
    );
}
export default SignUpV2;
